import React from 'react';
import styles from './CardOptionsView.module.scss';

export interface CardOptionsViewProps {
  children: React.ReactNode;
}

export const CardOptionsView = ({
  children
}: CardOptionsViewProps): React.ReactElement<CardOptionsViewProps> => {
  return <div className={styles.cardOptionsView}>{children}</div>;
};
